module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.position === 'center') ? _c('transition', {
    attrs: {
      "name": "ssui-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "ssui-dialog-wrapper",
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('div', {
    class: _vm.hasMask ? 'ssui-mask' : 'ssui-mask_transparent',
    on: {
      "click": function($event) {
        _vm.maskClose && (_vm.currentValue = false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ssui-dialog-content"
  }, [_vm._t("default")], 2)])]) : _c('div', {
    staticClass: "slide-dialog-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "ssui-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.hasMask ? 'ssui-mask' : 'ssui-mask_transparent',
    on: {
      "click": function($event) {
        _vm.maskClose && (_vm.currentValue = false)
      },
      "touchmove": _vm.onTouchMove
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ssui-slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "ssui-slide-content",
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b1c83b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1c83b0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@finance/ssvue/src/components/x-dialog/index.vue
// module id = 250
// module chunks = 8